import { useState, useEffect } from 'react';

export function useSanityContent<T>(fetchFn: () => Promise<T | null>, fallbackData: T) {
  const [content, setContent] = useState<T>(fallbackData);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadContent = async () => {
      try {
        setLoading(true);
        const data = await fetchFn();
        if (isMounted) {
          // Prioritize fetched data, only use fallback if fetch returns null
          setContent(data || fallbackData);
        }
      } catch (err) {
        if (isMounted) {
          setError(err as Error);
          console.error('Error loading Sanity content:', err);
          // On error, use fallback data
          setContent(fallbackData);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadContent();

    return () => {
      isMounted = false;
    };
  }, [fetchFn, fallbackData]);

  return { content, loading, error };
}
